import { render, staticRenderFns } from "./LeaveListApprover.vue?vue&type=template&id=47d577f6&scoped=true"
import script from "./LeaveListApprover.vue?vue&type=script&lang=js"
export * from "./LeaveListApprover.vue?vue&type=script&lang=js"
import style0 from "./LeaveListApprover.vue?vue&type=style&index=0&id=47d577f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d577f6",
  null
  
)

export default component.exports